import { render } from "./StatsBuilderSubRow.vue?vue&type=template&id=646d7ff4&scoped=true"
import script from "./StatsBuilderSubRow.vue?vue&type=script&lang=ts"
export * from "./StatsBuilderSubRow.vue?vue&type=script&lang=ts"

import "./StatsBuilderSubRow.vue?vue&type=style&index=0&id=646d7ff4&scoped=true&lang=scss"
script.render = render
script.__scopeId = "data-v-646d7ff4"

export default script